export default __webpack_public_path__ + "static/media/nasa.5e8799a1.jpg";